module.exports = __webpack_public_path__ + "img/kareha3.0a20e2a7.jpg";